import { AnchorHTMLAttributes } from 'react'

import styled from 'styled-components'

import { ButtonProps } from './Button'
import { CSSBase } from './CSSBase'
import { CSSBasePrimary } from './CSSBasePrimary'

const StyledAnchor = styled.a`
  ${CSSBase}

  ${CSSBasePrimary}
`

export function AnchorButton({
  children,
  icon,
  iconPosition = 'right',
  ...props
}: ButtonProps & AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <StyledAnchor {...props}>
      {iconPosition === 'left' && icon}
      <div>{children}</div>
      {iconPosition === 'right' && icon}
    </StyledAnchor>
  )
}
